import { Component, OnInit, HostBinding, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PrimaryKeySetting } from 'dbweb-core';
@Component({
	selector: 'common-clone',
	templateUrl: './clone.component.html',
	styleUrls: ['./clone.component.scss']
})
export class CloneComponent implements OnInit {
	@HostBinding('class.c-bill-colone') hostClass = true;
	@ViewChild('clone', { static: true })
	clone: ElementRef;
	// ç¨æ·å¡«åçå¼
	fillValues: string[];
	constructor(
		public dialogRef: MatDialogRef<CloneComponent>,
		@Inject(MAT_DIALOG_DATA) public data: PrimaryKeySetting[]
	) {}

	ngOnInit() {
		this.clone.nativeElement.parentElement.parentElement.style = 'padding:0px;';
	}
	ok() {
		const rev = {};
		this.data.forEach(v => {
			rev[v.Name] = v.Fill;
		});
		this.dialogRef.close(rev);
	}
	close() {
		this.dialogRef.close();
	}
}
